import { render } from "./notifications.vue?vue&type=template&id=4ec0f199&scoped=true"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import "./notifications.vue?vue&type=style&index=0&id=4ec0f199&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec0f199"]])

export default __exports__